<template>
  <v-layout wrap>
    <v-snackbar v-model="snackbar"  color="#FEBD08" :timeout="timeout" right app >
      <v-layout wrap>
        <v-flex xs11> {{msg}}</v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-flex xs6 class="hidden-sm-and-down">
      <v-img
        class="white--text align-end"
        height="100vh"
        :style="
          $vuetify.breakpoint.name == 'md' ? 'height:50vh' : 'height=100vh'
        "
        src="../../assets/images/login4.jpg"
      >
        <v-layout wrap>
          <v-flex xs12 pb-3>
            <span
              style="
                font-family: Times New Roman;
                font-size: 50px;
                padding-left: 8%;
              "
            >
              Direct from </span
            ><span style="font-family: blackbold; font-size: 50px">
              Hivekeepers.</span
            >
            <br />
            <span
              style="
                font-family: robotolight;
                line-height: 0.9;
                padding-left: 8%;
                font-size: 30px;
              "
              >A Good Source of antioxidants</span
            >
          </v-flex>
        </v-layout>
      </v-img>
    </v-flex>
    <v-flex xs12 md6 align-self-center text-center>
      <v-layout wrap justify-center py-5 py-sm-12 py-md-0>
        <v-flex xs12 sm7 px-2 md10 lg6>
          <v-form ref="form">
            <v-layout wrap>
              <v-flex xs12 style="font: 30px robotomedium" pb-5 pb-lg-12>
               Change Password
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[rules.email]"
                  label=" Enter your Email"
                  class="textfd"
                  v-model="email"
                  outlined
                  dense
                >
                </v-text-field>
              </v-flex>
             
              <v-flex xs12>
                <v-btn
                  @click="uploadData"
                  width="100%"
                  color="#FEBD08"
                  tile
                  style="color: white"
                >
                 Continue
                </v-btn>
              </v-flex>
              
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="hidden-xs-only hidden-lg-and-up" style="height: 150px">
    </v-flex>
  </v-layout>
</template>
<script>
 import axios from "axios";
// import store from "../../store";
export default {
  data() {
    return {
        msg:"",
      timeout:5000,
      snackbar: false,
    
      email: "",
      password: "",
      showPassword: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  methods: {
    uploadData() {
      if (this.$refs.form.validate()) {
      axios({
          method:"post",
          url:"/user/rest/password",
          data:
          {
           email:this.email
          }
      })
      .then((response) =>{
          if(response.data.status)
          {
         this.snackbar =true;
         this.msg =  response.data.msg;
         this.$router.push({
           path: "/getOTP",
         query:{
           searchkey :this.email,
         }
         })
          }
          else
          {
              this.snackbar =true;
              this.msg =response.data.msg


          }

      })
      }
    },
  },
};
</script>